<div class="download-our-app-section" [@slideOut]="contentVisibility">
  <p> Download Our App To Get more feature !</p>
  <button>Download Now</button>
  <i class="fa-solid fa-xmark" (click)="toggleContentVisibility()"></i>
</div>
